<template>
	<div
		class="g-block-title-left-lead g-block-title-padding"
		:class="{
			'g-block-title-left-lead--edit': editable,
			'is-active': editable && active,
			'g-block-title-left-lead--h5': h5,
			'g-block-title-padding--h5': h5,
		}"
		@click="onWrapClick"
	>
		<div class="g-block-title-left-lead__content">
			<div class="g-block-title-left-lead__part g-block-title-left-lead__part--primary" :style="{ color: themeColor }">
				<RichTextEditable
					v-if="editable"
					class="g-block-title-left-lead__text g-block-title-left-lead__text--primary"
					fit-content
					:model-value="data.primaryText"
					placeholder="主标题"
					@update:model-value="onPrimaryUpdate"
					@focus="onWrapClick"
				/>
				<div
					v-else
					class="g-block-title-left-lead__text g-block-title-left-lead__text--primary"
					v-html="data.primaryText || ''"
				></div>
			</div>
			<div class="g-block-title-left-lead__part g-block-title-left-lead__part--secondary" :style="{ color: lightColor }">
				<RichTextEditable
					v-if="editable"
					class="g-block-title-left-lead__text g-block-title-left-lead__text--secondary"
					fit-content
					:model-value="data.secondaryText"
					placeholder="副标题"
					@update:model-value="onSecondaryUpdate"
					@focus="onWrapClick"
				/>
				<div
					v-else
					class="g-block-title-left-lead__text g-block-title-left-lead__text--secondary"
					v-html="data.secondaryText || ''"
				></div>
			</div>
		</div>
	</div>
</template>

<script>
	import RichTextEditable from '../../../components/RichTextEditable.vue';
	import { dualTitleMixin } from '../shared/dualTitleMixin.js';

	export default {
		name: 'GBlockTitleLeftLead',
		components: { RichTextEditable },
		mixins: [dualTitleMixin],
	};
</script>

<style scoped lang="less">
	.g-block-title-left-lead {
		&--edit {
			border: 1px solid transparent;
			border-radius: 4px;
			transition: border-color 0.2s, box-shadow 0.2s;
			cursor: pointer;

			&.is-active {
				border-color: #285af9;
				box-shadow: 0 0 0 1px rgba(40, 90, 249, 0.15);
			}
		}
	}

	.g-block-title-left-lead__content {
		display: flex;
		flex-direction: column;
		gap: 8px;
		text-align: left;
	}

	.g-block-title-left-lead__text {
		display: inline-flex;
		line-height: 1.25;
		padding: 0;
		font-family: inherit;
		word-break: break-word;
		white-space: pre-wrap;
		color: inherit;

		&--primary {
			font-size: 28px;
			font-weight: 700;
		}

		&--secondary {
			font-size: 14px;
			font-weight: 400;
		}

		:deep(.g-rich-text-editable) {
			display: inline-flex;
			width: auto;
			max-width: 100%;
			color: inherit;
		}

		:deep(.g-rich-text-editable__content) {
			line-height: 1.25;
			min-height: unset;
			padding: 0;
			color: inherit;
		}

		:deep(span),
		:deep(font),
		:deep(p),
		:deep(div) {
			margin: 0;
			padding: 0;
			color: inherit;
		}
	}

	.g-block-title-left-lead--h5 {
		.g-block-title-left-lead__content {
			gap: 0.16rem;
		}

		.g-block-title-left-lead__text--primary {
			font-size: 0.56rem;
		}

		.g-block-title-left-lead__text--secondary {
			font-size: 0.28rem;
		}
	}
</style>
